import { render, staticRenderFns } from "./szModal.vue?vue&type=template&id=06b57b70&scoped=true"
import script from "./szModal.vue?vue&type=script&lang=js"
export * from "./szModal.vue?vue&type=script&lang=js"
import style0 from "./szModal.vue?vue&type=style&index=0&id=06b57b70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b57b70",
  null
  
)

export default component.exports